module.exports = __webpack_public_path__ + "node_modules/@fortawesome/fontawesome-free-webfonts/webfonts/fa-brands-400.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free-webfonts/webfonts/fa-brands-400.woff2
// module id = 658
// module chunks = 3